import React, { useState, useEffect } from 'react';
import ReactFlagsSelect from 'react-flags-select';
import { FormikProps } from 'formik';

interface CountrySelectProps {
  value: string;
  name?: string;
  setFieldValue: FormikProps<any>['setFieldValue'];
  label?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  required?: boolean;
}

const CountrySelect: React.FC<CountrySelectProps> = ({
  value,
  name,
  setFieldValue,
  label = 'Country',
  onChange,
  placeholder = 'Select a country',
  required = false,
}) => {
  const [isTouched, setIsTouched] = useState(false);

  useEffect(() => {
    // if (!value) {
    //   const event = {
    //     target: {
    //       name: name,
    //       value: 'NG',
    //     },
    //   } as React.ChangeEvent<HTMLInputElement>;
    //   setFieldValue(name ?? 'Country', 'NG');
    //   onChange(event);
    // }
    if (!value && name) {
      const defaultCountry = 'NG';
      setFieldValue(name, defaultCountry);
      const event = {
        target: {
          name: name,
          value: defaultCountry,
        },
      } as React.ChangeEvent<HTMLInputElement>;
      onChange(event);
    }
  }, [value, name]);

  const handleCountryChange = (countryCode: string) => {
    setIsTouched(true);
    const event = {
      target: {
        name: name,
        value: 'NG',
      },
    } as React.ChangeEvent<HTMLInputElement>;
    setFieldValue(name ?? 'Country', 'NG');
    onChange(event);
  };


  return (
    <div>
      <label className="block text-gray-600 font-medium">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <ReactFlagsSelect
        selected={value || 'NG'}
        onSelect={handleCountryChange}
        placeholder={placeholder}
        className={`inputContainer bg-white`}
        // searchable
        countries={['NG']}
        // value={value}
      />
      {/* {required && !isTouched && !value && (
        <span className="text-red-500 text-sm mt-1">
          This field is required
        </span>
      )} */}
    </div>
  );
};

export default CountrySelect;
